<style lang="less" scoped>
  .content {
    position: relative;
    flex-direction: column;
  }
  .progress {
    position: absolute;
    right: 0;
    top: 16px;
  }
  .card-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 320px;
    .card-component-slot {
      width: 180px;
      height: 249px;
      position: relative;
      .delete-button-component {
        position: absolute;
        right: 0;
        top: 0;
        margin-top: -5px;
        margin-right: -5px;
        z-index: 100;
        display: none;
      }
      &:nth-of-type(1),
      &:nth-of-type(3) {
        opacity: .6;
        position: absolute;
      }
      &:nth-of-type(1) {
        left: 0;
        transform: scale(.7) translateX(-80%);
      }
      &:nth-of-type(3) {
        right: 0;
        transform: scale(.7) translateX(80%);
      }
      &:nth-of-type(2) {
        .delete-button-component {
          display: block;
        }
      }
    }
  }
  .card-component {
    width: 100%;
    height: 100%;
  }
  .keypad-container {
    width: 100%;
  }
</style>

<template lang="pug">
  .std-layout
    .header
      header-component(
        @click-stop='redirectBack'
        @click-complete='done')
    .content
      progress-component.progress(
        :current='current + 1'
        :max='answerCount'
        :unit='"묶음"')
      .card-container
        .card-component-slot(v-for='(data, key) in display')
          delete-button-component.delete-button-component(
            @click.native='clearCurrentCard'
            v-if='countArray(payload[current])')
          card-component.card-component(
            v-if='data'
            :data='[data]')
      .keypad-container
        keypad-component(
          :used='payload'
          @pressed='keypad($event)')
    .footer
      footer-component(
        :time='time'
        @click-prev='prev'
        @click-next='next')
</template>

<script>
import HeaderComponent from '@/components/header/stop_submit';
import ProgressComponent from '@/components/current_max_progress';
import CardComponent from '@/components/card';
import KeypadComponent from '@/components/card_keypad';
import DeleteButtonComponent from '@/components/delete_button';
import FooterComponent from '@/components/footer/timer_arrow';

export default {
  data() {
    return {
      current: 0,
      time: 0,
      payload: [],
      display: [],
    };
  },
  watch: {
    current() {
      this.display = this.getDisplay();
    },
  },
  methods: {
    countArray(target) {
      if (typeof target !== 'object') {
        return 0;
      }
      const count = Object.keys(target).length;
      return count;
    },
    clearCurrentCard() {
      this.$set(this.payload, this.current, []);
      this.display = this.getDisplay();
    },
    redirectBack() {
      this.$router.go(-1);
    },
    done() {
      this.$store.commit('setInput', this.payload);
      this.$router.replace({ name: 'TrainingCardResult' });
    },
    prev() {
      if (this.current > 0) {
        this.current -= 1;
      }
    },
    next() {
      if (this.current + 1 < this.answer.length) {
        this.current += 1;
      }
    },
    progressTimer() {
      this.time += 1;
      if (this.time >= this.endTime) {
        this.done();
      }
    },
    keypad(data) {
      this.$set(this.payload, this.current, data);
      this.next();
      this.display = this.getDisplay();
    },
    getDisplay() {
      const result = [];
      let index = 0;
      for (let i = this.current - 1; i <= this.current + 1; i += 1) {
        if (this.answer[i]) {
          result[index] = this.payload[i];
          // result[index] = [{ shape: 'heart', card: '2' }];
        } else {
          result[index] = false;
        }
        index += 1;
      }
      return result;
    },
  },
  computed: {
    units() {
      return this.$store.state.app.units;
    },
    endTime() {
      return this.$store.state.app.recall * 60;
    },
    displayIndex() {
      const result = [];
      for (let i = this.current - 1; i <= this.current + 1; i += 1) {
        result.push(i);
      }
      return result;
    },
    answer() {
      const result = [];
      const answer = this.$store.state.app.answer;
      for (let i = 0; i < answer.length; i += 1) {
        const data = answer[i];
        for (let j = 0; j < data.length; j += 1) {
          result.push(data[j]);
        }
      }
      return result;
    },
    answerCount() {
      return this.answer.length;
    },
    // display() {
    //   const result = [];
    //   let index = 0;
    //   for (let i = this.current - 1; i <= this.current + 1; i += 1) {
    //     if (this.answer[i]) {
    //       result[index] = this.payload[i];
    //       // result[index] = [{ shape: 'heart', card: '2' }];
    //     } else {
    //       result[index] = false;
    //     }
    //     index += 1;
    //   }
    //   return result;
    // },
  },
  mounted() {
    window.intervalID = setInterval(this.progressTimer, 1000);
    this.display = this.getDisplay();
  },
  beforeDestroy() {
    clearInterval(window.intervalID);
  },
  created() {
    for (let i = 0; i < this.answer.length; i += 1) {
      this.payload[i] = [];
    }
  },
  components: {
    HeaderComponent,
    ProgressComponent,
    CardComponent,
    KeypadComponent,
    DeleteButtonComponent,
    FooterComponent,
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/training/card/recall.vue